import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-standard-list',
  templateUrl: './wills-default-list.component.html',
  styleUrls: ['./wills-default-list.component.scss']
})
export class WillsDefaultListComponent implements OnInit {

  @Input() object: any;
  @Input() key: any;
  @Input() extraData: any;

  constructor() { }

  ngOnInit() {
  }

}
